import {Component, Input, OnInit} from '@angular/core';
import {BaseModalComponent} from '../base-modal.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {ToastService} from '../../_services/toast.service';

@Component({
    selector: 'bb-change-party-size',
    templateUrl: './change-party-size.component.html',
    styleUrls: ['./change-party-size.component.scss'],
})
export class ChangePartySizeComponent extends BaseModalComponent implements OnInit {
    @Input() partySize: number;
    options = Array.from({length: 100}, (_, i) => i + 1);
    formGroup: FormGroup;

    constructor(
        modalController: ModalController,
        private formBuilder: FormBuilder,
        private toastService: ToastService
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            partySize: this.partySize
        });
    }

    onSubmit(partySize) {
        this.close(!!partySize ? partySize : 'NONE');
    }
}
